import React from 'react';
import cx from 'classnames';
import ErrorIcon from '../../assets/add-ons/exclamation.svg';
import InfoIcon from '../../assets/add-ons/info.svg';
import CheckmarkIcon from '../../assets/discount-codes/tick.svg';
import './index.css';

const renderMessage = ({ isError, errorMessage, infoMessage }) => {
  if (isError) {
    return (
      <div className="error__label">
        <ErrorIcon />
        <span>{errorMessage}</span>
      </div>
    );
  }

  if (infoMessage) {
    return (
      <div className="info__label">
        <InfoIcon />
        <span>{infoMessage}</span>
      </div>
    );
  }

  return null;
};

const renderCharacterCount = ({ showCharacterCount, maxLength, isCharacterCountValid, isError, value }) => {
  if (!showCharacterCount || !maxLength) {
    return null;
  }

  const currentClassName = cx('character-count__current', {
    'character-count--error': isError,
    'character-count--valid': isCharacterCountValid,
  });

  return (
    <div className="character-count">
      {isCharacterCountValid && <CheckmarkIcon className="character-count__icon--valid" />}
      <span className={currentClassName}>
        {value?.length || 0}
      </span>
      <span className="character-count__max">/{maxLength}</span>
    </div>
  );
};

export const Input = (props) => (
  <div className="custom-input-field">
    <label htmlFor={props.id}>
      {props.children}
      {props.required ? <span className="custom-input-field--required"> *</span> : null}
    </label>
    <div className="custom-input-container">
      {props.icon && props.icon()}
      <input
        id={props.id}
        type={props.type ? props.type : 'text'}
        autoComplete="off"
        value={props.value}
        onChange={props.onChange}
        maxLength={props.maxLength}
        placeholder={props.placeholder ? props.placeholder : null}
        className={cx(props.className || 'custom-input', { error: props.isError })}
        readOnly={props.readOnly}
        min={props.min ? props.min : undefined}
        onKeyDown={props.onKeyDown ? props.onKeyDown : undefined}
        disabled={props.disabled}
      />
      {props.isPercentage ? <span className="percent">%</span> : null}
    </div>

    <div className="input-footer">
      {renderMessage(props)}
      {renderCharacterCount(props)}
    </div>
  </div>
);
